import React, { useContext } from "react";

import classNames from "classnames";
import { observer } from "mobx-react";
import { useRouter } from "../../hooks/useNavigation";
import PropTypes from "prop-types";
import { Row } from "react-bootstrap";
import { isMobile } from "react-device-detect";

import JobCard from "../../../components/JobCard/JobCard";
import JobCardWithTitle from "../../../components/JobCardWithTitle/JobCardWithTitle";
import SimpleJobCard from "../../../components/SimpleJobCard/SimpleJobCard";
import ComponentContext from "../../../contexts/ComponentContext";
import { useStores } from "../../../contexts/StoreContext";
import ApplicationFormModal from "../SearchResults/ApplicationFormModal";
import GridVacancyDescriptiveItem from "../SearchResults/GridVacancyDescriptiveItem";
import GridVacancyDescriptiveItemReordered from "../SearchResults/GridVacancyDescriptiveItemReordered";
import GridVacancyItem from "../SearchResults/GridVacancyItem";

const jobCardComponentMap = {
  cardWithTitle: JobCardWithTitle,
  framedCard: GridVacancyItem,
  simple: SimpleJobCard,
  withDetails: JobCard,
  descriptiveFramedCard: GridVacancyDescriptiveItem,
  descriptiveItemReordered: GridVacancyDescriptiveItemReordered,
};

function JobList(props) {
  const { jobs } = props;

  const { modalStore } = useStores();
  const { openModal } = modalStore;
  const router = useRouter();

  const { jobCardType, jobsInRow } = useContext(ComponentContext);

  const JobCardComponent = jobCardComponentMap[jobCardType];

  const className = classNames("col-md-6", {
    [`col-lg-${12 / jobsInRow}`]: !!jobsInRow,
  });

  return (
    <Row className="gy-4">
      {jobs.map((job) => {
        const { id } = job;

        return (
          <div key={id} className={className}>
            <JobCardComponent
              onApplyClick={() => {
                openModal({
                  content: <ApplicationFormModal vacancy={job} />,
                  fullscreen: isMobile,
                });
                return false;
              }}
              onDetailsClick={() => router.push(`/job/${job.id}`)}
              vacancy={job}
            />
          </div>
        );
      })}
    </Row>
  );
}

JobList.propTypes = {
  jobs: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.string,
      id: PropTypes.string,
      location: PropTypes.shape({}),
      vacancyId: PropTypes.string,
    })
  ).isRequired,
};

export default observer(JobList);
